// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"74":"b670e6634786f9b1","720":"80c2a401dc5af9d9","908":"f5f2d932f9719f64"}[chunkId] + ".js";
};